<app-navbar title="Wycieczki">
	<a routerLink="./add" class="btn btn-primary me-2"> <i class="fas fa-plus"></i> Dodaj </a>
	<button class="btn btn-warning" (click)="filtersOpen()">
		<i class="fas fa-filter"></i>
	</button>
</app-navbar>

<app-resident-trip-list-filter
	userFilters="residentTripList"
	[destinations]="parameters.destinations"
	(selected)="filtersSelected($event)"
>
</app-resident-trip-list-filter>

<div class="my-4">
	<table class="table table-striped table-hover">
		<thead>
			<tr>
				<th>
					<span>Destynacja</span>
				</th>
				<th>
					<span>Wycieczka</span>
				</th>
				<th>
					<span>Data</span>
				</th>
				<th>
					<span>Ilość Miejsc</span>
				</th>
				<th>
					<span>Wolne</span>
				</th>
				<th></th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let item of data">
				<td>{{ item.destinations }}</td>
				<td>{{ item.name }}</td>
				<td>{{ item.date | formatDateTime }}</td>
				<td>{{ item.contigent }}</td>
				<td>{{ item.freePlaces }}</td>
				<td>
					<a
						routerLink="../reservationsPeopleList/{{ item.id }}&date={{ item.date }}"
						class="btn btn-success p-2"
						>Lista</a
					>
				</td>
				<td>
					<a routerLink="../residentTrips/{{ item.id }}" class="btn btn-primary p-2">>></a>
				</td>
			</tr>
		</tbody>
	</table>
</div>
